import { CmpMainPageContent } from "../../components/organisms/CmpPageContent/CmpMainPageContent";
import { CmpTemplates } from "../../components/template/CmpTemplates";

const CmpMainPages = (props: any) => {
  return (
    <CmpTemplates pageTitle="회원가입">
      <CmpMainPageContent {...props} />
    </CmpTemplates>
  );
};

export default CmpMainPages;
